import React from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Input } from 'antd'
import FormalityStepButton from '../FormalityStepButton'
import { FormInstance } from 'antd/es/form'

interface IProps {
  form: FormInstance
  onFinish: any
  loading?: boolean
}
const AuthorityRefuseConfirm = (props: IProps) => {
  const { t } = useTranslation('legalFormalities')
  const { form, onFinish, loading = false } = props

  const handleFinishRefuse = () => {
    const reason = form.getFieldValue('authority_refusal_reason')
    onFinish({
      authorityRefuse: true,
      authorityRefusalReason: reason,
    })
  }

  const refuseFormItems = () => {
    return (
      <>
        <h6>{t('show.form.submit.confirm.refuse.description')}</h6>
        <Form.Item
          name="authority_refusal_reason"
          label={t('show.form.authority_refusal_reason.label')}
        >
          <Input></Input>
        </Form.Item>
      </>
    )
  }

  return (
    <>
      <FormalityStepButton
        title={t('show.form.submit.confirm.refuse.title')}
        description={refuseFormItems()}
        buttonDisabled={loading}
        buttonLabel={t('show.form.submit.confirm.refuse.label')}
        onConfirm={handleFinishRefuse}
        danger={true}
      />
    </>
  )
}

export default AuthorityRefuseConfirm
